var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03208 4.15216C8.03208 3.09963 8.4502 2.09021 9.19445 1.34596C9.9387 0.60171 10.9481 0.183594 12.0007 0.183594C13.0532 0.183594 14.0626 0.60171 14.8069 1.34596C15.5511 2.09021 15.9692 3.09963 15.9692 4.15216C15.9692 5.2047 15.5511 6.21412 14.8069 6.95837C14.0626 7.70262 13.0532 8.12074 12.0007 8.12074C10.9481 8.12074 9.9387 7.70262 9.19445 6.95837C8.4502 6.21412 8.03208 5.2047 8.03208 4.15216ZM4.1938 10.6527C5.00165 9.88584 6.07305 9.45828 7.18694 9.45828C8.30083 9.45828 9.37223 9.88584 10.1801 10.6527L10.1972 10.6699L12.0007 12.4733L13.8058 10.6699L13.8229 10.6527C14.6306 9.88684 15.7013 9.45991 16.8144 9.45991C17.9274 9.45991 18.9981 9.88684 19.8058 10.6527C20.2065 11.0335 20.5257 11.4917 20.744 11.9995C20.9623 12.5074 21.0751 13.0543 21.0756 13.6071C21.076 14.1598 20.9642 14.7069 20.7468 15.2152C20.5294 15.7234 20.211 16.1822 19.8109 16.5636L12.5972 23.575C12.4372 23.7305 12.2229 23.8175 11.9998 23.8175C11.7767 23.8175 11.5624 23.7305 11.4024 23.575L4.19037 16.5636C3.79045 16.1823 3.47214 15.7237 3.25476 15.2157C3.03738 14.7077 2.92546 14.1609 2.92578 13.6083C2.9261 13.0557 3.03866 12.509 3.25663 12.0012C3.4746 11.4935 3.79343 11.0336 4.1938 10.6527Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase);
export default __webpack_public_path__ + "static/media/phase.fd282216af6ef8bd7846be61bdb21d16.svg";
export { ForwardRef as ReactComponent };